import React, { useState,useEffect } from "react";
import CtaLayout from "../components/CtaLayout";
import "../styles/common.css";
import "../styles/cta.css";


function CtaMarketing() {

  return (
    <>
      <CtaLayout title="お問い合わせ" lead="CONTACT">
      <div className='cta-box__text'>
        <h3>「どのように集客すればいいかわからない…」<br/>「広告を運用しているが、効果が伸び悩んでいる…」<br/>そんな課題をお持ちの方は、ぜひLOGOTにご相談ください。</h3>
        <p>競合に勝つためのWebマーケティング戦略から、問い合わせ・売上アップにつながる施策の実行まで、一貫した支援を提供します。<br/>広告運用・SEO対策・SNS活用など、Web集客の最前線で培ったノウハウを活かし、コンサルティング型のサポートも可能です。<br/>まずはお気軽に課題のお悩みについてお聞かせください。</p>
      </div>
    </CtaLayout>
    </>
  );
}

export default CtaMarketing;
